import http from '../http'

export default {
    /**
     * Consulta los modulos del usuario
     * @param {int} usuario
     * @returns {Promise}
     */
    all(usuario) {
        return http.get(`usuarios/${usuario}/modulos`);
    },

    /**
     * Consulta los modulos del usuario
     * @param {int} usuario
     * @returns {Promise}
     */
     resolve(usuario, modulo) {
        return http.post(`usuarios/${usuario}/modulos/${modulo}`);
    },

    /**
     * Desactiva un modulo a un usuario
     * @param {int} usuario
     * @returns {Promise}
     */
    delete(usuario, modulo) {
        return http.delete(`usuarios/${usuario}/modulos/${modulo}`);
    },
}